import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';
import VenueToastStack from '../components/feedback/VenueToastStack';

const VenueFeedbackContext = createContext({
  pushFeedback: () => {},
  dismissFeedback: () => {},
});

let feedbackCounter = 0;

export const VenueFeedbackProvider = ({ children }) => {
  const [feedbackItems, setFeedbackItems] = useState([]);

  const dismissFeedback = useCallback((id) => {
    setFeedbackItems((current) => current.filter((item) => item.id !== id));
  }, []);

  const pushFeedback = useCallback((payload) => {
    const item = {
      id: `venue-feedback-${feedbackCounter += 1}`,
      type: payload?.type || 'info',
      title: payload?.title || '',
      message: payload?.message || '',
      autoHideMs: payload?.autoHideMs ?? 3600,
    };

    setFeedbackItems((current) => [...current, item]);
    return item.id;
  }, []);

  const value = useMemo(
    () => ({
      pushFeedback,
      dismissFeedback,
    }),
    [dismissFeedback, pushFeedback]
  );

  return (
    <VenueFeedbackContext.Provider value={value}>
      {children}
      <VenueToastStack feedbackItems={feedbackItems} onDismiss={dismissFeedback} />
    </VenueFeedbackContext.Provider>
  );
};

export const useVenueFeedback = () => useContext(VenueFeedbackContext);

